import React from "react";
import { List } from "immutable";

const DisplayError = function displayError(props) {
  const { error, className } = props;

  if (!error) {
    return null;
  }

  if (typeof error === "string") {
    return <div className={className}>{error}</div>;
  }

  if (Array.isArray(error) || List.isList(error)) {
    return (
      <div>
        {error.map((err, idx) => (
          <div key={`${err}-${idx}`} className={className}>
            {err}
          </div>
        ))}
      </div>
    );
  }

  return null;
};

export default DisplayError;
